<template>
    <aside>
        <div class="titulo margem efeito">
            <div class="m-icone"><a href="#" class="icone-menu" title="Menu"
                    onclick="document.getElementById('main').classList.toggle('esconde');return false"></a></div>
            <nav class="jm jm-inc none" id="menuIncluir">
                <div class="separador">
                    <a href="#">Incluir projeto</a>
                    <a href="monitoramento.html">Incluir projeto</a>
                </div>
            </nav>
        </div>
        <!-- 138 Orçamento | Complementação
                139 Orçamento | Estrutura Plano de Contas
                140 Orçamento | Gerenciar Responsáveis Categorias
                141 Orçamento | Cadastro de Valores 
                142 Orçamento | Relatórios
                143 Orçamento | Estrutura de Receitas
                144 Orçamento | Cadastro de Receitas
                145 Orçamento | Produtos x Categorias
                146 Orçamento | Aprovação de Complementação -->
        <nav class="nav-maior separador" v-if="[139, 140, 141, 142].some(p => permissoes.includes(p))">
            <router-link v-if="permissoes.includes(139)" to="/" active-class="ativo">Estrutura de Plano de
                Contas</router-link>
            <router-link v-if="permissoes.includes(140)" to="/associar" active-class="ativo">Responsáveis</router-link>
            <router-link v-if="permissoes.includes(141)" to="/cadastrar/orcamento/manual" active-class="ativo"> Gestão
                Orçamentária</router-link>
            <router-link v-if="permissoes.includes(142)" to="/relatorio/orcamento"
                active-class="ativo">Relatórios</router-link>
        </nav>
        <nav class="nav-maior separador" v-if="[145].some(p => permissoes.includes(p))">
            <router-link v-if="permissoes.includes(145)" to="/produtos" active-class="ativo">Produtos x Categorias de
                Despesa</router-link>
        </nav>
        <nav class="nav-maior separador" v-if="[138].some(p => permissoes.includes(p))">
            <router-link v-if="permissoes.includes(138)" to="/complementacao" active-class="ativo">Painel de Recursos de
                Orçamento e Complementações</router-link>
            <router-link v-if="permissoes.includes(146)" to="/solicitacoes" active-class="ativo">Solicitações de
                Complementação de Orçamento</router-link>
        </nav>
        <nav class="nav-maior separador" v-if="[143, 144].some(p => permissoes.includes(p))">
            <router-link v-if="permissoes.includes(143)" to="/receitas" active-class="ativo">Classes de
                Receitas</router-link>
            <router-link v-if="permissoes.includes(144)" to="/cadastrar/receita" active-class="ativo">Gestão de
                Receitas</router-link>
        </nav>
    </aside>
</template>
<script>
import { getPermissao } from "../../services/permissao-service";

export default {
    name: 'NovoMenuLateral',

    data() {
        return {
            permissoes: ''
        }
    },

    methods: {
        estrutura() {
            this.$router.push('/estrutura');
        },

        associar() {
            this.$router.push('/associar')
        },
        cadastrar() {
            this.$router.push('/cadastrar/orcamento/manual');
        },
        relatorio() {
            this.$router.push('/relatorio/orcamento');
        },
        orcamento() {
            this.$router.push('/orcamentos');
        },
    },

    async created() {
        this.permissoes = await getPermissao();

    }

};
</script>
